import ApiService from '@/services/core/api.service'

const LiveStockService = {
  async get (query) {
    return ApiService.get(`admin/live-stocks?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/live-stocks', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/live-stocks/${payload.id}`, payload)
  }
}

export default LiveStockService
